// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-picker[data-v-5d542740] {
  display: inline-flex;
  align-items: center;
  height: 44px;
}
.upload-picker__progress[data-v-5d542740] {
  width: 200px;
  max-width: 0;
  transition: max-width var(--animation-quick) ease-in-out;
  margin-top: 8px;
}
.upload-picker__progress p[data-v-5d542740] {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.upload-picker--uploading .upload-picker__progress[data-v-5d542740] {
  max-width: 200px;
  margin-right: 20px;
  margin-left: 8px;
}
.upload-picker--paused .upload-picker__progress[data-v-5d542740] {
  animation: breathing-5d542740 3s ease-out infinite normal;
}
@keyframes breathing-5d542740 {
  0% {
    opacity: .5;
  }
  25% {
    opacity: 1;
  }
  60% {
    opacity: .5;
  }
  to {
    opacity: .5;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/upload/dist/assets/index-oN7s9A_M.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,wDAAwD;EACxD,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".upload-picker[data-v-5d542740] {\n  display: inline-flex;\n  align-items: center;\n  height: 44px;\n}\n.upload-picker__progress[data-v-5d542740] {\n  width: 200px;\n  max-width: 0;\n  transition: max-width var(--animation-quick) ease-in-out;\n  margin-top: 8px;\n}\n.upload-picker__progress p[data-v-5d542740] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.upload-picker--uploading .upload-picker__progress[data-v-5d542740] {\n  max-width: 200px;\n  margin-right: 20px;\n  margin-left: 8px;\n}\n.upload-picker--paused .upload-picker__progress[data-v-5d542740] {\n  animation: breathing-5d542740 3s ease-out infinite normal;\n}\n@keyframes breathing-5d542740 {\n  0% {\n    opacity: .5;\n  }\n  25% {\n    opacity: 1;\n  }\n  60% {\n    opacity: .5;\n  }\n  to {\n    opacity: .5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
